import classNames from 'classnames';
import { cloneElement } from 'react';
import { Form } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import { useWindowSize } from '../../../hooks';
import { InfoIcon } from '../../InfoIcon';
import { TooltippedText } from '../../TooltippedText';
import { IShiftPreset } from './ShiftPreset.model';

import './ShiftPreset.scss';

interface PresetControlProps {
  preset: IShiftPreset;
  colSize: number;
  index: number;
  onApplyPreset: (preset: IShiftPreset) => void;
  id?: string;
}

export const ShiftPreset = ({ preset, colSize, onApplyPreset, id }: PresetControlProps) => {
  const {
    tooltip,
    count,
    icon,
    label,
    type,
    active,
    partlyActive,
    intermediate,
    intermediateCount,
  } = preset;
  const size = useWindowSize();

  return (
    <Col xs={colSize} className="ps-2 pe-2 preset">
      <Form.Check
        className={classNames(
          'preset-card border w-100 p-0 rounded bg-white d-flex align-items-start position-relative',
          {
            active: active,
            partlyActive: partlyActive && !active,
            intermediate,
          }
        )}
        id={id || type.toString()}
        ref={(input) => {
          if (input) {
            input.indeterminate = intermediate;
          }
        }}
        label={
          <div
            className={classNames('preset-card-padding position-relative', {
              ['cursor-pointer']: !(active || intermediate),
            })}
          >
            <div
              className={classNames('d-flex w-100', {
                ['mb-3']: size?.width > 819,
                ['justify-content-center']: size?.width < 819,
                ['justify-content-between']: size?.width > 819,
              })}
            >
              <span className="d-flex">
                {cloneElement(icon, {
                  className: 'preset-icon',
                })}
              </span>
              <div className={classNames('hidden', 'absolute', { ['d-flex ']: size?.width > 819 })}>
                {!!count && <span>{count}</span>}
                {!!intermediateCount && (
                  <span className="text-color-gray">
                    <span className="ms-1 me-1">/</span>
                    <span>{intermediateCount}</span>
                  </span>
                )}
              </div>
            </div>
            <div className="shift-type-label" style={{ gap: 5 }}>
              <h6 className="mb-0">{label}</h6>
              {size?.width > 819 && (
                <TooltippedText tooltipContent={tooltip}>
                  <InfoIcon size={16} className="ms-1 profile-info-icon" />
                </TooltippedText>
              )}
            </div>
          </div>
        }
        type="checkbox"
        checked={active}
        onChange={() => onApplyPreset(preset)}
      />
    </Col>
  );
};
